import PasswordForgotten from './PasswordForgotten';

export default PasswordForgotten;
